/*
 * Finish choices on a routine step page (for example Style).
 * Filters the comparison table and the product grid to the products chosen for a finish.
 * Without JavaScript every product stays visible; product links are always in the HTML.
 */
if (!customElements.get('routine-finish-filter')) {
  class RoutineFinishFilter extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.routine-filter__button'));
      this.textElement = this.querySelector('.routine-filter__text');
      this.handles = [];

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(button));
      });

      const gridContainer = document.getElementById('ProductGridContainer');
      if (gridContainer) {
        this.observer = new MutationObserver(() => this.apply());
        this.observer.observe(gridContainer, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    select(selectedButton) {
      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', button === selectedButton ? 'true' : 'false');
      });
      const handles = selectedButton.dataset.handles || '';
      this.handles = handles ? handles.split(',') : [];
      if (this.textElement) this.textElement.textContent = selectedButton.dataset.text || '';
      this.apply();
    }

    matches(handle) {
      return this.handles.length === 0 || this.handles.includes(handle);
    }

    handleFromLink(element) {
      const link = element.querySelector('a[href*="/products/"]');
      if (!link) return null;
      const path = new URL(link.href, window.location.origin).pathname;
      const parts = path.split('/products/');
      return parts.length > 1 ? parts[1].split('/')[0] : null;
    }

    apply() {
      if (this.observer) this.observer.disconnect();

      document.querySelectorAll('.routine-category__table tbody tr[data-handle]').forEach((row) => {
        row.hidden = !this.matches(row.dataset.handle);
      });

      document.querySelectorAll('#product-grid .grid__item').forEach((item) => {
        const handle = this.handleFromLink(item);
        item.hidden = handle ? !this.matches(handle) : false;
      });

      const gridContainer = document.getElementById('ProductGridContainer');
      if (this.observer && gridContainer) {
        this.observer.observe(gridContainer, { childList: true, subtree: true });
      }
    }
  }

  customElements.define('routine-finish-filter', RoutineFinishFilter);
}
